import http from './http.service';

class UserService {
    constructor() {
        this.$http = http;
        this.baseUrl = "/api/user";
    }

    getById(id) {
        if (!id) {
            throw new Error('Id is required');
        }

        return this.$http.get(`${this.baseUrl}/getById`, { params: { id: id } })
    };

    delete(id) {
        if (!id) {
            throw new Error('Id is required');
        }

        return this.$http.delete(`${this.baseUrl}/delete`, { params: { id: id } });
    };

    removeMasterPerson(userId, personId) {
        if (!userId) {
            throw new Error('Id is required');
        }

        return this.$http.delete(`${this.baseUrl}/removeMasterPerson`, { params: { userId: userId, personId: personId } });
    };

    addMasterPerson(userId, personId) {
        if (!userId) {
            throw new Error('Id is required');
        }

        return this.$http.put(`${this.baseUrl}/addMasterPerson`, { userId, personId });
    };

    create(model) {
        if (!model) {
            throw new Error('Model is required');
        }

        return this.$http.post(`${this.baseUrl}/createUser`, model);
    };

    update(model) {
        if (!model) {
            throw new Error('Model is required');
        }

        return this.$http.put(`${this.baseUrl}/updateUser`, model);
    };

    removeMergedPerson(personId, masterPersonId) {
        if (!personId || !masterPersonId) {
            throw new Error('Person Id and Master person Id are required');
        }

        return this.$http.delete(`${this.baseUrl}/removeMergedPerson`, { params: { personId: personId, masterPersonId: masterPersonId } });
    };

    mergedPerson(personId, masterPersonId) {
        if (!personId || !masterPersonId) {
            throw new Error('Person Id and Master person Id are required');
        }

        return this.$http.post(`${this.baseUrl}/mergedPerson`, { personId: personId, masterPersonId: masterPersonId });
    };

    getLoggedUserEmails() {
        return this.$http.get(`${this.baseUrl}/GetLoggedUserEmails`);
    };
}

export default new UserService();
